import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { FontProvider } from "./context/FontContext";
import { SoundProvider } from "./context/SoundContext";
import { IconPackProvider } from "./context/IconPackContext";

import { library } from "@fortawesome/fontawesome-svg-core";
import * as solid from "@fortawesome/free-solid-svg-icons";
import * as regular from "@fortawesome/free-regular-svg-icons";
import { LanguageProvider } from "./context/LanguageContext";
import { DateTimeProvider } from "./context/DateTimeContext";
import ToastContainer from "./components/Toast/ToastContainer";
import { MenuProvider } from "./context/MenuContext";

function extractIcons(pack: Record<string, any>): solid.IconDefinition[] {
  return Object.values(pack).filter(
    (item): item is solid.IconDefinition =>
      typeof item === "object" && "iconName" in item
  );
}

library.add(
  ...extractIcons(solid),
  ...extractIcons(regular)
);
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

const root = ReactDOM.createRoot(rootElement);

root.render(
    <BrowserRouter>
      <DateTimeProvider>
        <MenuProvider>
          <LanguageProvider>
            <ThemeProvider>
              <FontProvider>
                <SoundProvider>
                  <IconPackProvider>
                    <ToastContainer />
                    <App />
                  </IconPackProvider>
                </SoundProvider>
              </FontProvider>
            </ThemeProvider>
          </LanguageProvider>
        </MenuProvider>       
      </DateTimeProvider>
    </BrowserRouter>
);
